import m from 'mithril'

class Liker {
    constructor() {}
    //static fetch() {
    //    return m.request({
    //        method: 'GET',
    //        url: `${window.BASE_URL}/Citizen/GetLikerItems`
    //    })
    //}

    static save(data) {
        return m.request({
            method: 'POST',
            url: `${window.BASE_URL}/Citizen/saveLikerItems`,
            data: data
        })
    }
}

export default Liker